import { AdminCollectionEditor } from '../../_Shared/_UI/AdminCollectionEditor';
import { AdminViewLayout } from '../../_Shared/_UI/AdminViewLayout';
import { ADMIN_FEATURED_FILTER, ADMIN_VISIBILITY_FILTER } from '../../_Shared/_Config/AdminCollectionFilters';
import { BLOG_ADMIN_API as API } from '../_MODULES/_API';
import '../../_Shared/_UI/_Styles/PortfolioAdmin.css';

const BLOG_FILTERS = [
    ADMIN_VISIBILITY_FILTER,
    ADMIN_FEATURED_FILTER,
    {
        key: 'category_filter',
        field: 'category',
        label: 'Categorias',
        type: 'multi',
        placeholder: 'Seleccionar categorias…',
    },
    {
        key: 'tags_filter',
        field: 'tags',
        label: 'Tags',
        type: 'multi',
        tokenize: true,
        matchMode: 'any',
        placeholder: 'Seleccionar tags…',
    },
    {
        key: 'published_exact',
        field: 'published_at',
        label: 'Fecha exacta',
        type: 'date',
        placeholder: 'Elegir fecha',
    },
    {
        key: 'published_range',
        field: 'published_at',
        label: 'Rango de publicacion',
        type: 'dateRange',
        placeholder: 'Desde — hasta',
        col: 2,
    },
];

const BLOG_ORDER = [
    { value: 'date-desc', label: 'Mas recientes', field: 'published_at', direction: 'desc', type: 'date' },
    { value: 'date-asc', label: 'Mas antiguos', field: 'published_at', direction: 'asc', type: 'date' },
    { value: 'sort-asc', label: 'Orden manual ↑', field: 'sort_order', direction: 'asc', type: 'number' },
    { value: 'sort-desc', label: 'Orden manual ↓', field: 'sort_order', direction: 'desc', type: 'number' },
    { value: 'title-asc', label: 'Titulo A → Z', field: 'title', direction: 'asc', type: 'text' },
    { value: 'title-desc', label: 'Titulo Z → A', field: 'title', direction: 'desc', type: 'text' },
];

export const BlogViewMain = () => (
    <AdminViewLayout
        pageKey="blog"
        title="Blog"
        description="Publica articulos con portada, categoria, tags, tiempo de lectura y contenido largo. La web los muestra en una seccion moderna y responsive."
    >
        <AdminCollectionEditor
            title="Publicaciones"
            listEndpoint={API.LIST}
            saveEndpoint={API.SAVE}
            removeEndpoint={API.REMOVE}
            titleField="title"
            subtitleField="category"
            imageField="image"
            searchFields={['title', 'slug', 'category', 'tags', 'excerpt', 'content', 'read_time']}
            filters={BLOG_FILTERS}
            orderOptions={BLOG_ORDER}
            fields={[
                { name: 'image', label: 'Portada', type: 'image', span: 2 },
                { name: 'title', label: 'Titulo' }, { name: 'slug', label: 'Slug (opcional)' },
                { name: 'category', label: 'Categoria' }, { name: 'published_at', label: 'Fecha', type: 'date' },
                { name: 'read_time', label: 'Tiempo de lectura' }, { name: 'tags', label: 'Tags separados por coma', type: 'tags' },
                { name: 'excerpt', label: 'Extracto', type: 'textarea', rows: 3, span: 2 },
                { name: 'content', label: 'Contenido (separa parrafos con una linea vacia)', type: 'textarea', rows: 10, span: 2 },
                { name: 'sort_order', label: 'Orden', type: 'number', defaultValue: 0 },
                { name: 'featured', label: 'Destacado', type: 'checkbox' }, { name: 'active', label: 'Visible', type: 'checkbox', defaultValue: true },
            ]}
        />
    </AdminViewLayout>
);
